import { useLocSettings } from "../hooks/SettingsHooks";
import IconWithPopup from "./IconWithPopup";

const IconsOrTagline = ({
  specsIndexed,
  showLabel = false,
  sku,
  noTooltips = false,
  tagline = ""
}: {
  sku?: string;
  specsIndexed?: Record<
    string,
    { field?: string; value: string; unit?: string; description?: string }
  >;
  showLabel?: boolean;
  tagline?: string | null;
  noTooltips?: boolean;
}) => {
  const settings = useLocSettings();

  const icons = Object.entries(specsIndexed || {})
    .map(([field, { value, unit, description }]) => {
      const icon = settings.specifications?.[field]?.icons?.[value];
      return icon ? { field, value, unit, description, showLabel, sku } : null;
    })
    .filter(icon => icon !== null);

  return icons.length
    ? icons.map(({ field, value, unit, showLabel, sku }) => {
        return (
          <IconWithPopup
            field={field}
            value={value}
            unit={unit}
            showLabel={showLabel}
            key={field + "_" + value}
            sku={sku}
            noTooltip={noTooltips}
          />
        );
      })
    : tagline;
};

export default IconsOrTagline;
